import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Frame', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M5.5 2.91666H2.49996C2.03972 2.91666 1.66663 3.28976 1.66663 3.75V6.72359M14.5 2.91666H17.5C17.9602 2.91666 18.3333 3.28976 18.3333 3.75V6.73599M18.3333 13.2756V16.25C18.3333 16.7102 17.9602 17.0833 17.5 17.0833H14.5M5.3962 17.0833H2.49996C2.03972 17.0833 1.66663 16.7102 1.66663 16.25V13.2512",
    stroke: "white",
    "stroke-width": "1.66667",
    "stroke-linecap": "round"
  }), React.createElement("path", {
    d: "M14.5 5.91667H5.49996C5.03972 5.91667 4.66663 6.28977 4.66663 6.75001V13.25C4.66663 13.7103 5.03972 14.0833 5.49996 14.0833H14.5C14.9602 14.0833 15.3333 13.7103 15.3333 13.25V6.75001C15.3333 6.28977 14.9602 5.91667 14.5 5.91667Z",
    stroke: "white",
    "stroke-width": "1.66667"
  }))));
});